module.exports = __webpack_public_path__ + "static/Giorgio-Maric-2da3bdccba70663419fc1d81da7bd735.jpg";